import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'James Whitfield',
    role: 'CEO',
    company: 'Meridian Capital Group',
    quote: 'Vertex completely transformed our digital acquisition strategy. Within 90 days, our cost per qualified lead dropped by 63% while lead volume tripled. The team operates like an extension of our business — strategic, responsive, and relentlessly focused on outcomes.',
    rating: 5,
    metric: '63% lower CPL',
    avatar: 'JW',
    color: 'from-blue-500 to-cyan-500',
  },
  {
    name: 'Sarah Chen',
    role: 'VP of Marketing',
    company: 'NovaTech Solutions',
    quote: 'We were spending $80K/month on ads with mediocre results. Vertex rebuilt our entire funnel and media strategy from scratch. Six months later, we hit $1.2M in monthly revenue with better margins than ever. These are the real operators you want running your growth.',
    rating: 5,
    metric: '$1.2M monthly revenue',
    avatar: 'SC',
    color: 'from-violet-500 to-purple-500',
  },
  {
    name: 'Michael Torres',
    role: 'Founder',
    company: 'Atlas Wealth Advisory',
    quote: 'Finding a marketing partner who understands financial services compliance AND performance marketing is nearly impossible. Vertex delivered both. Our HNW lead pipeline went from unpredictable to a consistent, scalable machine. Best investment we made this year.',
    rating: 5,
    metric: '488% more qualified leads',
    avatar: 'MT',
    color: 'from-emerald-500 to-teal-500',
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="section-padding bg-vertex-gradient-light relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-vertex-500/10 border border-vertex-500/20 mb-6">
            <span className="text-vertex-600 text-sm font-semibold">Client Testimonials</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-vertex-900 mb-5">
            Trusted by Growth-Focused
            <span className="gradient-text"> Leaders</span>
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            Don't just take our word for it. Here's what our clients have to say about partnering with Vertex.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="group bg-white rounded-2xl p-8 border border-gray-100 card-hover hover:shadow-2xl relative"
            >
              {/* Quote Icon */}
              <Quote className="w-10 h-10 text-vertex-100 mb-4" />
              
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                "{t.quote}"
              </p>

              {/* Metric Badge */}
              <div className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${t.color} text-white mb-6`}>
                {t.metric}
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-6 border-t border-gray-100">
                <div className={`w-11 h-11 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center text-white font-bold text-sm`}>
                  {t.avatar}
                </div>
                <div>
                  <div className="font-display font-bold text-vertex-900 text-sm">{t.name}</div>
                  <div className="text-gray-500 text-xs">{t.role}, {t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
